(function () {
  "use strict";

  angular
    .module('trainerWebApp.services')
    .factory('catalogModel', catalogModel);

  function catalogModel() {
    var originalCatalog = {};

    var service = {
      catalog: {},
      setCatalog: setCatalog,
      catalogDirty: catalogDirty,
      revert: revert,
      save: save,
      removeItem: removeItem,
      getName: getName,
      cleanCatalogForServer: cleanCatalogForServer
    };

    return service;

    ///////////////

    function setCatalog(newCatalog) {
      if (!newCatalog.items) newCatalog.items = [];
      if (!newCatalog.groups) newCatalog.groups = [];

      // catalog names with "Untitled" are displayed as ''
      newCatalog.displayName = ~newCatalog.name.indexOf('Untitled Catalog') ? null : newCatalog.name;

      originalCatalog = angular.copy(newCatalog);
      service.catalog = newCatalog;
    }

    function catalogDirty() {
      var i, c;

      // props
      var props = ['name', 'displayName', 'description', 'accessType', 'courseAccessType', 'traineeAccessType'];
      for (i = 0, c = props.length; i < c; i++) {
        if (service.catalog[props[i]] === '')
          service.catalog[props[i]] = null;
        if (originalCatalog[props[i]] != service.catalog[props[i]])
          return true;
      }

      // items
      if (originalCatalog.items.length != service.catalog.items.length)
        return true;

      for (i = 0, c = originalCatalog.items.length; i < c; i++) {
        if (originalCatalog.items[i].courseId != service.catalog.items[i].courseId)
          return true;
      }

      // groups
      if (originalCatalog.groups.length != service.catalog.groups.length)
        return true;

      for (i = 0, c = originalCatalog.groups.length; i < c; i++) {
        if (originalCatalog.groups[i].id != service.catalog.groups[i].id)
          return true;
      }

      return false;
    }

    function revert() {
      service.catalog = angular.copy(originalCatalog);
    }

    function save() {
      originalCatalog = angular.copy(service.catalog);
    }

    function removeItem(index) {
      if (!service.catalog.items[index]) return;
      service.catalog.items.splice(index, 1);
    }

    function getName() {
      return service.catalog.displayName ? service.catalog.displayName : service.catalog.name;
    }

    function cleanCatalogForServer() {
      var itemIds = [];
      for (var i = 0, len = service.catalog.items.length; i < len; i++) {
        itemIds[i] = parseInt(service.catalog.items[i].courseId, 10);
      }
      var name = getName();
      return {
        id: parseInt(service.catalog.id, 10),
        name: name,
        description: service.catalog.description || null,
        accessType: service.catalog.accessType,
        courseAccessType: service.catalog.courseAccessType,
        traineeAccessType: service.catalog.traineeAccessType,
        itemIds: itemIds,
        userGroupIds: _.map(service.catalog.groups, function (group) {
          return group.id;
        })
      };
    }
  }

})();
